export default {
  utility_search_subtitle_all: 'avisar a todos los usuarios del canal',
  utility_search_subtitle_online:
    'avisar a todos los usuarios del \u00faltimo/de los \u00faltimos {minute} min',
};
